<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="!disableFields"
          class="mr-4 mt-4"
          v-on="on"
          small
          absolute
          dark
          fab
          top
          right
          color="primary"
          @click="newArea"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Adicionar nova área</span>
    </v-tooltip>
    <h2
      style="font-size:19px !important;"
      class="title text-sm-left grey--text text--darken-1 mt-1 mb-4 ml-1"
    >Lista de áreas</h2>
    <v-layout column style="max-height: 290px;">
      <v-flex md6 style="overflow: auto">
        <v-data-table
          no-data-text="Ainda não há áreas cadastradas"
          :headers="headers"
          :items="[...areas]"
          flat
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              <v-icon color="success" v-if="props.item.active">check_circle</v-icon>
              <v-icon color="error" v-if="!props.item.active">block</v-icon>
            </td>
            <td class="text-xs-left">
              <v-text-field
                :ref="props.item.id"
                :disabled="props.item.disab"
                class="caption"
                :rules="[]"
                v-model="props.item.name"
              ></v-text-field>
            </td>
            <td class="text-xs-left">
              <v-text-field
                :disabled="props.item.disab"
                class="caption"
                :rules="[]"
                v-money="$store.state.maskMoney.M2X2"
                v-model="props.item.available_area"
              ></v-text-field>
            </td>
            <td class="text-xs-left">
              <v-text-field
                :disabled="props.item.disab"
                class="caption"
                :rules="[]"
                v-money="$store.state.maskMoney.M2X2"
                v-model="props.item.cmq_area"
              ></v-text-field>
            </td>
            <td class="text-xs-left">
              <v-text-field
                :disabled="props.item.disab"
                class="caption"
                :rules="[]"
                v-money="$store.state.maskMoney.M2X2"
                v-model="props.item.boma_area"
              ></v-text-field>
            </td>
            <td class="text-xs-left">
              <template v-if="!disableFields">
                <v-btn
                  @click="props.item.disab = true"
                  v-if="!props.item.disab"
                  flat
                  icon
                  color="light-blue darken-4"
                >
                  <v-icon small>library_add</v-icon>
                </v-btn>
                <div v-if="props.item.disab">
                  <v-menu
                    :outline="false"
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn :outline="false" flat icon color="primary" v-on="on">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <!-- <v-btn color="primary" dark v-on="on">Scale Transition</v-btn> -->
                    </template>
                    <v-list>
                      <v-list-tile
                        @click="item.func(props.item, item.label)"
                        v-for="(item, i) in menuItens"
                        :key="i"
                      >
                        <v-list-tile-title style="font-size:14px">
                          <v-icon
                            style="font-size:18px"
                          >{{ (item.active=='active' && !props.item.active) ? item.icon2 : item.icon }}</v-icon>
                          {{ (item.active=='active' && !props.item.active) ? item.label2: item.label}}
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  name: 'CondominiumAreas',

  directives: {
    money: VMoney,
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },

  props: {
    disableFields: { type: Boolean, default: false },
    dataAreas: Array
  },

  data () {
    return {
      sort: true,
      menuItens: [
        { label: 'Editar', icon: 'edit', func: this.edit },
        { label: 'Remover', icon: 'delete', func: this.confirmDelArea },
        {
          active: 'active',
          label: 'Desativar',
          label2: 'Ativar',
          icon: 'block',
          icon2: 'check_circle',
          func: this.confirmToogleStatusItem
        }
      ],
      headers: [
        { text: 'Status', align: 'center', value: 'active', sortable: false },
        { text: 'Nome da área', align: 'left', value: 'name', sortable: false },
        {
          align: 'left',
          text: 'Área útil',
          value: 'available_area',
          sortable: false
        },
        { align: 'left', text: 'Área CMQ', value: 'cmq_area', sortable: false },
        {
          align: 'left',
          text: 'Área BOMA',
          value: 'boma_area',
          sortable: false
        },
        { align: 'center', text: 'Ações', value: 'actions', sortable: false }
      ]
    }
  },

  computed: {
    areas () {
      return [...this.dataAreas]
    }
  },

  methods: {
    confirmToogleStatusItem (data) {
      let action = data.action ? 'desativar' : 'ativar'
      let obj = {
        message: `Você deseja ${action} a área "${data.name}"?`,
        title: `${data.action ? 'Desativar área' : 'Ativar área'}`,
        callback: _ => {
          this.toogleStatusItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    toogleStatusItem (data) {
      if (data.id.toString().indexOf('temp-') > -1) {
        this.updateStatusArea(data.id)
        return
      }
      let obj = {
        url: '/api/building/desative/' + data.id,
        query: '',
        method: 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Status modificado com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.updateStatusArea(data.id)
      })
    },

    updateStatusArea (id) {
      var index = this.dataAreas.findIndex(area => area.id === id)
      this.dataAreas[index].active = !this.dataAreas[index].active
    },

    confirmDelArea (data) {
      let obj = {
        message: `Você deseja excluir o usuário "${data.name}"?`,
        title: 'Excluir usuário',
        callback: _ => {
          this.delArea(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    removeArea (id) {
      var index = this.dataAreas.findIndex(area => area.id === id)
      this.dataAreas.splice(index, 1)
    },

    delArea (data) {
      if (data.id.toString().indexOf('temp-') > -1) {
        this.removeArea(data.id)
        return
      }
      let obj = {
        /* http://127.0.0.1:9000/api/building/desative/1 */
        url: '/api/building/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Usuário removido com sucesso`,
          type: 'success'
        }
        this.removeArea(data.id)
        this.$store.commit('showAlert', opts)
      })
    },

    edit (data, label) {
      data.disab = false
      let idFocus = data.id.toString()
      this.$nextTick(() => this.$refs[idFocus].focus())
    },

    newArea () {
      let temId = 'temp-' + new Date().getTime()
      const newLine = {
        id: temId,
        disab: false,
        active: 1,
        available_area: '',
        boma_area: '',
        cmq_area: '',
        created_at: '',
        name: ''
      }
      this.dataAreas.unshift(newLine)
      this.$nextTick(() => this.$refs[temId].focus())
      let tabArea = document.querySelectorAll(
        '#condominiumTab .v-tabs__item'
      )[2]
      tabArea.classList.remove('tabError')
    }
  }
}
</script>

<style>
.caption input[type="text"]:disabled {
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
